import { render, staticRenderFns } from "./create-blog.html?vue&type=template&id=77cbf924&scoped=true&external"
import script from "./create-blog.js?vue&type=script&lang=js&external"
export * from "./create-blog.js?vue&type=script&lang=js&external"
import style0 from "./create-blog.scss?vue&type=style&index=0&id=77cbf924&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cbf924",
  null
  
)

export default component.exports